import { useSelector } from "react-redux";

/** Admin picks org per request; property managers use JWT-scoped org from login. */
export const useAccountingScope = () => {
	const roleFromState = useSelector((state) => state.role);
	const isAdminFlag = useSelector((state) => state.isAdmin);
	const managerDetails = useSelector((state) => state.managerDetails);

	const role = roleFromState || (isAdminFlag === 1 ? "admin" : "manager");
	const isAdmin = role === "admin";
	const isManager = role === "manager";
	const requiresOrganizationSelection = isAdmin;
	const sessionOrganization = isManager ? managerDetails?.related_organization ?? null : null;

	return {
		role,
		isAdmin,
		isManager,
		requiresOrganizationSelection,
		sessionOrganization,
	};
};

export const buildAccountingOrgParams = (organizationId, requiresOrganizationSelection) => {
	if (!requiresOrganizationSelection) return {};
	if (!organizationId) return {};
	return { organization_id: organizationId };
};

export const canLoadAccountingData = (requiresOrganizationSelection, organizationId) =>
	!requiresOrganizationSelection || Boolean(organizationId);
